
<app-page-header title="Profile"></app-page-header>
<div class="row">
  <div class="col-lg-6 offset-lg-3">

      <div class="card">
      <div class="card-header">Security</div>
      <div class="card-body">
        <form [formGroup]="form" method="post">


          <nexus-form-row control_id="priority-input" row_label="Multi Factor Authentication" label_class="col-sm-4 col-md-5" value_class="col-sm-8 col-md-5">
            <kendo-switch id="priority-input" formControlName="mfa_enabled"></kendo-switch>
          </nexus-form-row>
          <nexus-form-row control_id="retrieval-wait-input" *ngIf="user_mfa_setting_model?.mfa_enabled" label_class="col-sm-4 col-md-5" value_class="col-sm-8 col-md-5">
            <div class="d-flex flex-row align-items-center flex-wrap">
              <input type="radio" checked>
              <div class="m-1">
                Email ({{user_mfa_setting_model.email}})
              </div>
          </div>

        </nexus-form-row>
          <nexus-form-row label_class="col-sm-4 col-md-5" value_class="col-sm-8 col-md-5">
            <button kendoButton [primary]="true" [icon]="'check'" (click)="submit()" [disabled]="!form.valid">Save</button>
          </nexus-form-row>
        </form>
        <nexus-form-result [model]="form_result"></nexus-form-result>
      </div>

    </div>

  </div>
</div>
